<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

import { TButton } from '@/components/ui/button';
import { TTooltip, TTooltipContent, TTooltipTrigger } from '@/components/ui/tooltip';
import { useUserMeQuery } from '@/queries/users/use-users-me-query';

const { disabled } = defineProps<{
  disabled?: boolean;
}>();

const router = useRouter();
const { t: $t } = useI18n();

const { data: user } = useUserMeQuery();

const walletEUR = computed(() => user.value?.wallets?.[0]?.value ?? 0);
const hasNoFunds = computed(() => walletEUR.value === 0);

const goToWithdraw = () => {
  return router.push('/withdraw');
};
</script>
<template>
  <TTooltip :disabled="!hasNoFunds">
    <TTooltipTrigger as-child>
      <TButton
        :disabled="hasNoFunds || disabled"
        variant="gray"
        size="fluid-default"
        @click="goToWithdraw"
      >
        {{ $t('layout.navBar.userDropdown.withdraw') }}
      </TButton>
    </TTooltipTrigger>
    <TTooltipContent>
      <p class="m-3 font-semibold leading-5">
        {{ $t('layout.navBar.userDropdown.withdrawNoFundsTooltip') }}
      </p>
    </TTooltipContent>
  </TTooltip>
</template>
